<template>
  <el-aside
    width="180px"
    class="layout-sider-nav">
    <div class="sider-title">
      <img src="./5d0b5f5226aa5.png" />
    </div>
    <el-menu
      :default-active="active"
      :unique-opened="true"
      background-color="#000"
      text-color="#BFCBD9"
      active-text-color="#fff">
      <template v-for="(menu) in menuData">
        <el-submenu
          v-if="menu.children"
          :key="menu.activePath + ''"
          :index="menu.activePath + ''">
          <span slot="title">{{ menu.menuName }}</span>
          <el-menu-item-group>
            <el-menu-item
              v-for="(children) in menu.children"
              :key="children.activePath + ''"
              :index="children.activePath + ''"
              @click="openUrl(children.funcAddress)"
            >{{ children.menuName }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-else
          :key="menu.activePath + ''"
          :index="menu.activePath + ''"
          @click="openUrl(menu.funcAddress)">
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapState } from 'vuex'
// import Menu from '@/utils/baseMenuMap'
export default {
  name: 'LayoutSider',
  components: {},
  data() {
    return {
      // defaultActive: '-1'
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      // menuData: state => state.account.menu,
      module: state => state.account.module
    }),
    active() {
      return this.$route.meta.activePath
    },
    menuData() {
      const activeTopPath = this.$route.meta.activeTopPath
      const menu = this.module.find(s => s.activePath === activeTopPath) || {}
      return menu.children
    }
  },
  watch: {
    $route() {
      // this.initMenu()
    }
  },
  created() {
    // this.initMenu()
  },
  methods: {
    openUrl(url) {
      this.$store.commit('common/resetQuery', {})
      this.$router.push(url)
    }
    // initMenu() {
    //   const path = this.$route.path
    //   this.menuData.forEach(item => {
    //     if (item.funcAddress) {
    //       if ((Menu[item.funcAddress.split('?')[0]] || []).indexOf(path) > -1) {
    //         this.defaultActive = item.menuId + ''
    //       }
    //     } else {
    //       item.children.forEach(sItem => {
    //         if (sItem.funcAddress) {
    //           if (
    //             (Menu[sItem.funcAddress.split('?')[0]] || []).indexOf(path) > -1
    //           ) {
    //             this.defaultActive = sItem.menuId + ''
    //           }
    //         }
    //       })
    //     }
    //   })
    // }
  }
}
</script>
<style lang="stylus">
.layout-sider-nav {
  // width: 200px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #000;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.5);
  z-index: 10;

  .el-menu {
    border-right: none;

    .el-submenu .el-menu-item {
      height: 42px;
      line-height: 42px;
    }

    .el-menu-item, .el-submenu__title {
      height: 48px;
      line-height: 48px;
    }

    .el-menu-item.is-active {
      background-color: #1890ff !important;
    }

    .el-menu-item-group__title {
      display: none;
    }

    .el-menu-item-group .el-menu-item:not(.is-active) {
      background-color: #000c17 !important;
    }
  }

  .sider-title {
    // height: 60px;
    color: #fff;
    font-size: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;

    img {
      width: 40%;
      margin-top: 12px;
    }
  }
}
</style>
